<template>
    <div class="form-header">
        <div class="cookbook-wrapper">
            <img class="ta-magazine" src="/images/fr_multigift_carousel/TA-Magazine-Mockup-NL.png" alt="magazine">
            <div>
                <h4><br><span>Bedankt, je <br> hebt je e-book <br> per e-mail <br> ontvangen.</span></h4>
            </div>
        </div>
        <div class="thanks-cookbook">
            <h4>Ga verder, voor <br>
                slechts €2, ontvang je <br> <span>je welkomstgeschenk <br> zoals deze Airfryer.</span></h4>
            <img class="pack-img" :src="form_side_image">
            <p>krijg je toegang tot al onze <br> diensten en onze tijdschriften.</p>
        </div>


        <b-button class="button is-primary next-button" @click="nextStep()">Bevestigen</b-button>
        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>


</template>

<script>
import mixin from "../../../travel_step_mixin";
import {get} from "vuex-pathify";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";
import ScrollLink from "../../../../../../views/_commons/nl/ScrollLink.vue";
import image_mixin from "../../../../../../views/_commons/fr/mixins/image_mixin";

export default {
    mixins: [mixin,image_mixin],
    components:{ScrollLink},
}
</script>
